/**
 * applys a color Set to a caolors 2 object for categorica values
 */
export const applyCategoricalColors = (colors2, colorSet) => {
  colors2.categorical.values.forEach((catValue, idx) => {
    catValue.color = colorSet[idx + 1] ? colorSet[idx + 1] : colorSet[colorSet.length - 1];
  });
  return colors2;
};

/**
 * applies a color set with category labels to a color 2 object
 */
export const autoApplyCategories = (colors2, colorSet, catLabels) => {
  colors2.categorical.values = [];
  colorSet.forEach((color, idx) => {
    const itemColor = colorSet[idx + 1] ? colorSet[idx + 1] : colorSet[colorSet.length - 1];
    if (catLabels[idx]) colors2.categorical.values.push({ color: itemColor, value: catLabels[idx] });
  });
  return colors2;
};
